<template>

  <div v-if="!walletLogin" class="gate">
    <div class="logo-container">
      <div class="crest">
        <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="#d4af37" stroke-width="1.6">
          <rect x="4" y="5" width="16" height="14" rx="2"/>
          <path d="M8 9h8M8 13h5"/>
        </svg>
      </div>
      <p>{{ $t('orderPage.noOrders') }}</p>
    </div>
    <w3m-button v-if="!walletConnected" :label="this.$t('walletConnected')" :loadingLabel="this.$t('openWallet')"/>
    <button v-if="walletConnected && !walletLogin" class="login-button" @click="toWalletLogin">{{$t('login')}}</button>
  </div>
  <main v-if="walletLogin">
    <div class="empty" v-if="data.length == 0"> <span>{{ $t('orderPage.noOrders') }}</span></div>
    <div class="investment-list" v-if="data.length>0">
      <div  v-for="(item, index) in data" :key="index" @click=ToViewOrder(item) class="investment-item">
        <div class="row-top">
          <div class="investment-title">{{item.product_name}}</div>
          <div class="status">{{orderStatus[item.status]}}</div>
        </div>
        <div class="investment-detail">
          <div class="info">{{$t('orderPage.arp')}} <span>{{item.arp}}%</span></div>
          <div class="info">{{$t('orderPage.end_time')}} <span>{{item.end_at_date}}</span><span>{{item.end_at_time}}</span></div>
        </div>
      </div>
    </div>
  </main>

  <div v-if="loading" class="loading-overlay" >
    <div class="loading-spinner"></div>
  </div>

</template>

<script>

import axios from 'axios';
import {mapState} from "vuex";
import config from "@/config";
import {getCookie} from "@/utils/cookie";

export default {
  name: 'OrderPage',
  data() {
    return {
      loading: false,
      data: [],
      orderStatus:{
        0:this.$t('orderPage.lockedPos'),
        1:this.$t('orderPage.waitRed'),
        2:this.$t('orderPage.redComple'),
        3:this.$t('orderPage.unexpected')
      }
    };
  },
  watch: {
    walletLogin(newValue, oldValue) {
      if(newValue){
        this.fetchData();
      }
      console.log('someData walletLogin changed from', oldValue, 'to', newValue);
    }
  },
  created() {
  },
  mounted() {
    if(this.walletLogin){
      this.fetchData();
    }
  },
  computed: {
    ...mapState({
      walletConnected: state => state.walletConnected,
      walletLogin: state => state.walletLogin,
      accountAddress: state => state.accountAddress,
      walletConnectModel: state => state.walletConnectModel,
      team_arp: state => state.team_arp,
      balance: state => state.balance,
      level: state => state.level,
      account_info: state => state.account_info,
    }),
  },
  methods: {
    ToViewOrder(item){
      this.$router.push({ name: "OrderDetail", params: {
        id: item.id,
          product_name: item.product_name,
          arp: item.arp,
          create_at: item.create_at,
          end_at: item.end_at,
          et_arp: item.everday_team_arp,
          status: item.status,
          amount:item.amount,
          } });
    },
    async toWalletLogin(){
      try {
        this.$store.commit('setShowWalletMsg',this.$t('go_wallet_to_do'));
        await this.$store.dispatch('walletLogin');
        this.$store.commit('setShowWalletMsg',"");
      } catch (error) {
        console.error('Failed to disconnect:', error);
      }
    },
    async fetchData() {
      this.loading = true
      axios.get(config.apiHost+'/order_list', {
        headers: {
          'Content-Type': 'application/json',
          'loginsign':getCookie("signature"),
          'Loginmsg':getCookie("login_msg"),
        }
      }).then(response => {
        // 处理响应数据
        var data = response.data
        if(data.login){
          this.data = data.data;
        }else{
          this.$store.commit('setLoginOut')
          this.$router.push({ name: "MyPage", params: {} });
        }
        this.loading = false
      }).catch(error => {
        this.loading = false
        // 处理错误
        console.error(error);
      });
    },
  },
};

</script>

<style scoped>
.empty {
  text-align: center;
  color: #9aa3b5;
  padding: 48px 0;
}

.investment-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-bottom: 5rem;
}

.investment-item {
  background: rgba(16, 22, 35, 0.9);
  padding: 18px;
  border-radius: 16px;
  color: white;
  border: 1px solid rgba(212, 175, 55, 0.16);
}

.row-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.investment-title {
  font-size: 1.05rem;
  font-weight: 600;
}

.status {
  font-size: 0.72rem;
  color: #f0d78c;
  border: 1px solid rgba(212, 175, 55, 0.28);
  border-radius: 999px;
  padding: 4px 10px;
  white-space: nowrap;
}

.investment-detail {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.investment-detail .info {
  display: flex;
  flex-direction: column;
  color: #8d96a8;
  font-size: 0.78rem;
}

.investment-detail .info span {
  margin-top: 5px;
  font-size: 0.95rem;
  color: #3ee0a0;
}

.gate {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 110px 24px 0;
  text-align: center;
}

.logo-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 24px;
  color: #9aa3b5;
}

.crest {
  width: 76px;
  height: 76px;
  border-radius: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(212, 175, 55, 0.1);
  border: 1px solid rgba(212, 175, 55, 0.28);
  margin-bottom: 14px;
}

.login-button {
  padding: 12px 40px;
  background: linear-gradient(180deg, #f3d98a 0%, #c9a227 100%);
  color: #1a1404;
  border: none;
  border-radius: 999px;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
}
</style>
